<template>
  <div class="flex flex-wrap">
    <div class="avatar-person flex mb-3" v-for="(item, index) in personList" :key="index">
      <el-tooltip :disabled="isOriginator" placement="bottom">
        <!-- tooltip内容 -->
        <template #content>
          <div class="flex py-1 px-1">
            <!-- 头像 -->
            <div style="border-radius: 50%" class="bg-theme img-box w-10 text-center h-10 leading-10 mr-3">
              <img v-if="item.photo" style="border-radius: 50%" class="w-full h-full" :src="item.photo" />
              <span v-else class="text-white text-medium">{{item.name.substr(-2)}}</span>
            </div>
            <div>
              <!-- 姓名 -->
              <span class="leading-22 opacity-85 text-medium-x font-medium">{{ item.name }}</span>
              <span class="text-small opacity-65 ml-1">{{item.deptName || getDeptName(item)}}</span>
              <!-- 联系方式 -->
              <p class="text-small opacity-65 mt-1 font-normal">{{ item.phone || item.mobile }}</p>
            </div>
          </div>
        </template>
        <div :class="{ flex: isOriginator,'text-center':true } ">
          <!-- 头像 -->
          <div
            :class="['img-box', 'h-10', 'text-center', 'mb-1', isOriginator ? 'mr-2' : '']"
          >
            <div style="border-radius: 50%" class="relative inline-block w-10 h-10 bg-theme">
              <img style="border-radius: 50%" v-if="item.photo" class="w-full h-full" :src="item.photo" />
              <span style="border-radius: 50%" v-else class="inline-block w-full h-full leading-10 text-white text-medium">{{item.name.substr(-2)}}</span>
              <!-- 删除按钮(小红圈) -->
              <div
                v-if="!isOriginator && !isCheck"
                style="width: 14px; height: 14px; line-height: 14px; border-radius: 50%; left: 30px; bottom: 28px"
                class="del absolute bg-danger flex flex-col cursor-pointer justify-cente"
                @click="deletePerson(item.id)"
              >
                <span style="height: 1.17px; width: 5.83px" class="inline-block bg-white m-auto"></span>
              </div>
            </div>
            
          </div>
          <!-- 姓名 -->
          <div>
            <p
              :class="[
                'leading-22',
                'opacity-85',
                'text-center',
                isOriginator ? 'text-medium-x' : 'text-medium',
                isOriginator ? 'font-medium' : 'font-normal'
              ]"
            >
              {{ item.name }}
            </p>
            <!-- 联系方式 -->
            <p v-if="isOriginator" class="text-small opacity-65 mt-1 font-normal">{{ item.phone }}</p>
          </div>
        </div>
      </el-tooltip>
      <!-- 右箭头 -->
      <i v-if="isShowQianjin(index)" style="margin-top: 13px" :class="['icon-qianjin', 'text-medium', 'opacity-45', 'mx-3']"></i>
      <!-- 添加+按钮 -->
      <div v-if="index + 1 === personList.length && multiple && !isCheck" class="add" @click="addPerson">
        <i class="icon-tianjia"></i>
        <p class="leading-3">选择{{ type }}人</p>
      </div>
    </div>
    <div v-if="!personList.length && !isCheck" class="add" @click="addPerson">
      <i class="icon-tianjia"></i>
      <p class="leading-3">选择{{ type }}人</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOriginator: {
      //是否为审批人
      type: Boolean,
      default: false
    },
    isCheck: {
      //是否为查看
      type: Boolean,
      default: false
    },
    multiple: {
      //是否可多选
      type: Boolean,
      default: false
    },
    type: {
      //类型
      type: String,
      default: ''
    },
    personList: {
      //数据列表
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // personList: []
    }
  },
  mounted() {},
  methods: {
    getDeptName(value) {
      return (value.organs??[]).map(o => o.name).join(',')
    },
    addPerson() {
      this.$emit('add-person', this.type)
    },
    deletePerson(id) {
      this.$emit('delete-person', { id, type: this.type })
    }
  },
  computed: {
    isShowQianjin(){
      return function(index){
        if(this.isCheck){
          return this.multiple && this.personList.length-1 !== index
        }else{
          return this.multiple
        }
      }
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.add {
  width: 72px;
  height: 68px;
  border: 1px solid;
  @apply text-center cursor-pointer border-ccc rounded-small;
  &:hover {
    @apply border-theme;
  }
  &:hover i,
  &:hover p {
    @apply opacity-100 text-theme;
  }
  i {
    font-size: 24px;
    @apply inline-block opacity-45 mt-3;
  }
  p {
    @apply text-small opacity-45 mt-1;
  }
}
</style>
